module.exports = __webpack_public_path__ + "img/woman-with-documents-from-right.f6bad594.svg";